import {ShippingAddressOrder} from '@domain/model/Account/Address/domain/model/ShippingAddress/ShippingAddress';

import {OrderServiceType} from './OrderServiceType';
import {OrderStatusType} from './OrderStatus';

export interface OrderService {
  id: string;
  boxId: string;
  type?: OrderServiceType;
  cesionId?: string;
  frequency?: number;
  shippingAddress?: ShippingAddressOrder;
  status: OrderStatusType;
  nextBoxDate?: Date;
  estimatedCarrierDeliveryAt?: string;
  promoCode?: string;
  dateCreated?: Date;
  comment?: string;
  isInterimOrder?: boolean;
  userNextBoxDate?: string;
  factoringAuthorized?: boolean;
}
